import React from "react";
import "./studentsLife.css";
import placementImg from "../../assets/images/placements.jpg"; // Replace with your image
import studentLifeImg from "../../assets/images/studentsLife.jpg"; // Replace with your image
import { FaBriefcase, FaStar } from "react-icons/fa";
import CountUp from "react-countup";

const StudentsLife = () => {
  return (
    <>
     
      {/* Students Life Section */}
      <section className=" studentsLife-section">
        <div className="container">
             <div className="row align-items-center">
                <div className="col-lg-12 col-md-12">
                    <div className="sudentsLife-title">
                        <h2>Students Life</h2>
                        <p>
                            Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit
                        </p>
                    </div>
                </div>
             </div>
          <div className="row align-items-center">

            {/* Image */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <div className="student-life-img">
                <img
                  src={studentLifeImg}
                  alt="student life"
                  className="img-fluid rounded shadow"
                />
                <div className="overlay-text">
                  <h5>Discover Campus Life</h5>
                  <a href="/" className="explore-btn">
                    Explore More →
                  </a>
                </div>
              </div>
            </div>

            {/* Info Cards */}
            <div className="col-lg-6 col-md-12">
              <div className="row g-3">
                <div className="col-6">
                  <div className="info-card">
                    <FaStar className="info-icon" />
                    <h5>Student Clubs</h5>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit ut
                      aliquam purus.
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="info-card">
                    <FaStar className="info-icon" />
                    <h5>Global Experiences</h5>
                    <p>
                      Excepteur sint occaecat cupidatat non proident, sunt in
                      culpa qui officia.
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="info-card">
                    <FaStar className="info-icon" />
                    <h5>Arts & Culture</h5>
                    <p>
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore.
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="info-card">
                    <FaStar className="info-icon" />
                    <h5>Sports Events</h5>
                    <p>
                      Quis nostrud exercitation ullamco laboris nisi ut aliquip
                      ex ea commodo consequat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       {/* Placement Section */}
      <section className="studentsLife-placement py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Image */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <img
                src={placementImg}
                alt="placements"
                className="img-fluid rounded shadow"
              />
            </div>

            {/* Stats Boxes */}
            <div className="col-lg-6 col-md-12">
              <div className="row g-3">
                <div className="col-6">
                  <div className="stat-box green place-text">
                    <FaBriefcase className="icon" />
                    <h4>Total Placements</h4>
                    <p>
                        <CountUp start={0} end={4500} duration={3} suffix="" />
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-box yellow place-text">
                    <FaBriefcase className="icon" />
                    <h4>Total Percentage</h4>
                    <p><CountUp start={0} end={92} duration={3} suffix="" /></p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-box red place-text">
                    <FaBriefcase className="icon" />
                    <h4>Corporates</h4>
                    <p><CountUp start={0} end={150} duration={3} suffix="" /></p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="stat-box blue place-text">
                    <FaBriefcase className="icon" />
                    <h4>Total Companies</h4>
                    <p><CountUp start={0} end={200} duration={3} suffix="" /></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default StudentsLife;
